import React, { FC, ReactNode } from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import Dropdown from '@components/shared/form/Dropdown'
import Title from '@models/Title'
import { generateAvailableAuthorizedPerformers } from '@models/util/product.util'

interface Props {
  title?: Title
  value: number | ''
  setValue: (quantity: number) => void
  className?: string
  children?: ReactNode
}

const SelectAuthorizedPerformers: FC<Props> = ({
  title,
  value = '',
  setValue,
  className,
  children,
}: Props) => {
  const { t } = useTranslation()
  if (!title?.product) return null
  const purchasedQuantity = title?.purchased_product?.purchased_quantity || 0
  const options = generateAvailableAuthorizedPerformers(title?.product, purchasedQuantity, t)
  return (
    <div className={classNames(className)}>
      <>
        {children}
        <Dropdown
          name={t('label.authorizedPerformers')}
          className="min-w-[110px] self-start"
          variant="sm"
          value={value}
          onChange={(e) => setValue(Number(e.target.value))}>
          <option disabled></option>
          {options.map(({ value, label }, idx) => {
            return (
              <option key={idx} value={value}>
                {label}
              </option>
            )
          })}
        </Dropdown>
      </>
    </div>
  )
}

export default SelectAuthorizedPerformers
